<template>
    <div id="buyingTaskHCM" class="page-content">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>买货登记</el-breadcrumb-item>
            <el-breadcrumb-item>买货任务</el-breadcrumb-item>
        </el-breadcrumb>

        <section class="seaerch-wrapper">
            <el-form class="search-form" :model="queryParams" ref="queryForm">
                <el-form-item label="要求购买完成日期" prop="dateRange" label-width="130px">
                    <el-date-picker v-model="dateRange" value-format="yyyy-MM-dd" type="daterange" style="width: 100%;"
                        range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" size="small"
                        @change="dataChange"></el-date-picker>
                </el-form-item>

                <el-form-item label="购买平台" prop="platform" label-width="130px">
                    <el-select v-model="queryParams.platform" clearable placeholder="购买平台" size="small">
                        <el-option v-for="item in shopPlatform" :key="item.value" :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="店铺名称" prop="shopname" label-width="130px">
                    <el-input v-model="queryParams.shopname" clearable placeholder="店铺名称" size="small" />
                </el-form-item>

                <el-form-item label="购买产品" prop="productname" label-width="130px">
                    <el-input v-model="queryParams.productname" clearable placeholder="购买产品" size="small" />
                </el-form-item>

                <el-form-item label="购买规格" prop="specification" label-width="130px">
                    <el-input v-model="queryParams.specification" clearable placeholder="购买规格" size="small" />
                </el-form-item>

                <el-form-item label="指派人" prop="dealername" label-width="130px" v-if="logintype == 'HCM'">
                    <el-select v-model="queryParams.dealername" clearable placeholder="指派人" size="small" >
                        <el-option v-for="item in appointorList" :key="item.dealername" :label="item.dealername"
                            :value="item.dealername">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="任务编码" prop="tasknumber" label-width="130px">
                    <el-input v-model="queryParams.tasknumber" clearable placeholder="任务编码" size="small" />
                </el-form-item>

                <el-form-item label="是否买货" prop="rewardsstatus" label-width="130px">
                    <el-select v-model="queryParams.rewardsstatus" clearable placeholder="是否买货" size="small" >
                        <el-option v-for="item in maihuoList" :key="item.key" :label="item.name"
                            :value="item.key">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label-width="130px">
                    <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
                    <!-- <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button> -->
                </el-form-item>
            </el-form>
        </section>
        <div style="background-color: white;padding: 20px;">
            <el-row :gutter="10" class="mb8" style="padding-bottom: 20px;">
                <el-col :span="1.5">
                    <el-button type="primary" icon="el-icon-plus" size="mini" @click="handleAdd"
                        v-if="logintype == 'HCM'">任务</el-button>
                </el-col>
                <el-col :span="1.5">
                    <el-button size="mini" @click="allHandleAdd" v-if="logintype == 'HCM'">{{ buttonText }}</el-button>
                </el-col>
                <el-col :span="1.5">
                    <el-button size="mini" @click="designateAdd" v-if="logintype == 'HCM'">批量指派</el-button>
                </el-col>
                <el-col :span="1.5">
                    <el-button size="mini" @click="taskFeedback" v-if="logintype == 'HCM'">任务反馈</el-button>
                </el-col>
                <el-col :span="1.5">
                    <el-button size="mini" @click="importTemplate">下载数据</el-button>
                </el-col>
                <el-col :span="1.5">
                    <el-button size="mini" @click="onOpenDeleteDia(2)" v-if="logintype == 'HCM'">批量删除</el-button>
                </el-col>
            </el-row>
            <div class="prompt">
                <i class="el-icon-warning" style="margin: 0px 10px 0px 20px;color: #108cee;"></i>
                共<span class="promptFont">{{ totalNum }}</span>项,已选择<span class="promptFont">{{ openNumber }}</span>项
                <span class="promptFont2" @click="toggleSelection([tableData])">勾选全部</span>
                <span class="promptFont">/</span>
                <span class="promptFont2" @click="toggleSelection()">取消勾选</span>
            </div>
            <el-table v-loading="loading" :data="tableData" @row-click="taskidFun" ref="multipleTable"
                @selection-change="handleSelectionChange">
                <el-table-column type="selection"></el-table-column>
                <el-table-column label="任务编码" align="left" key="tasknumber" prop="tasknumber" />
                <el-table-column label="是否买货" align="left" key="rewardsstatus" prop="rewardsstatus" />
                <el-table-column label="指派人" align="left" key="dealername" prop="dealername" />
                <el-table-column label="购买平台" align="left" key="platform" prop="platform" />
                <el-table-column label="店铺名称" align="left" key="shopname" prop="shopname" />
                <el-table-column label="购买产品" align="left">
                    <template slot-scope="scope">
                        <div style="width: 200px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                            {{ scope.row.productname }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="规格" align="left" key="specification" prop="specification" />
                <el-table-column label="管控标准" align="left" key="controlstandard" prop="controlstandard" />
                <el-table-column label="购买链接" align="left">
                    <template slot-scope="scope">
                        <div style="width: 300px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                            {{ scope.row.productlink }}
                        </div>
                    </template>
                </el-table-column>

                <el-table-column label="要求购买完成日期" align="left" key="completedate" prop="completedate" />
                <el-table-column label="购买要求" align="left" key="purchaserequirement" prop="purchaserequirement" />
                <el-table-column label="停止购买要求" align="left" key="stopbuyingrequest" prop="stopbuyingrequest" />
                <el-table-column label="创建时间" align="left">
                    <template slot-scope="scope">
                        {{ scope.row.createtime | fullTime }}
                    </template>
                </el-table-column>
                <el-table-column label="创建人" align="left" key="createuser" prop="createuser" />
                <el-table-column label="更新时间" align="left">
                    <template slot-scope="scope" v-if="scope.row.updatetime">
                        {{ scope.row.updatetime | fullTime }}
                    </template>
                </el-table-column>
                <el-table-column label="更新人" align="left" key="updateuser" prop="updateuser" />
                <el-table-column label="操作" align="left" width="100" v-if="logintype != 'HCM'">
                    <template slot-scope="scope">
                        <el-button size="mini" type="text" @click.stop="handleUpdate(scope.row)">买货</el-button>
                        <el-button size="mini" type="text" @click.stop="dealerTask(scope.row)"
                            style="margin-left: 10px;">反馈</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div v-show="this.tableData.length > 0">
                <pagination :currentPage="currentPage" :pageSizes="[10, 20, 50, 100]" :total="totalNum"
                    @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
                </pagination>
            </div>
        </div>
        <!-- 删除 -->
        <el-dialog title="提示" :visible.sync="deleteShow" width="360px" style="margin-top: 10%;" id="dialog">
            <div style="display: flex;width: 100%;justify-content:center;">
                <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
                <div>
                    <div style="font-size: 16px;">
                        你确认要删除<span>{{ delType }}</span>货任务吗？
                    </div>
                    <div style="font-size: 14px;">删除后
                        <span style="color: #e90e24;font-size: 14px;">
                            (删除买货任务之前需要先删除相关的买货&转寄记录，已奖励的记录无法删除)？
                        </span>
                        并且不可恢复
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="deleteClassification" size="mini" :loading="ficationLoading">确
                    定</el-button>
                <el-button @click="delCancel" size="mini" type="TheCustom">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 批量指派 -->
        <el-dialog title="批量指派" :visible.sync="designateShow" width="550px" style="margin-top: 10%;" id="dialog">
            <el-form label-width="70px" :model="form" :rules="rules" ref="form">
                <el-form-item label="指派人" prop="dealerid" style="margin-top: 20px;">
                    <el-select v-model="form.dealerid" clearable placeholder="指派人" style="width: 410px" size="small"
                        @change="dealChange">
                        <el-option v-for="item in dealernameList" :key="item.id" :label="item.dealername"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="assignTaskDealer" size="mini" style="margin-right: 10px;">确
                    定</el-button>
                <el-button @click="designateShow = false" size="mini" type="TheCustom">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 批量任务 -->
        <el-dialog title="批量任务" class="importModal" :visible.sync="BulkImportShow" :close-on-click-modal="false"
            width="640px" id="dialog">
            <div class="wrap" style="margin: 10px;">
                <el-upload ref="newupload" class="upload-demo" drag action="hcm/hcmOrdertaskbmc/hcmOrderTaskBmcImport"
                    :auto-upload="false" multiple :before-upload="beforeUpload" accept=".xls,.xlsx"
                    :on-success="confirmUpload">
                    <i class="el-icon-upload" style="color: #BDA571;"></i>
                    <div class="el-upload__text" style="font-size: 16px;color: #333333;">将文件拖到此处，或<em>点击上传</em>
                        <br>
                        <span style="font-size: 14px;color: #d4d4d4;">
                            支持扩展名：.xls .xlsx
                        </span>
                    </div>
                    <el-button type="text" @click="download">下载导入模板</el-button>
                </el-upload>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="BulkImport()" size="small" :loading="bulLoading">确 定</el-button>
                <el-button @click="BulkImportShowf()" style="margin-left: 10px;" size="small" type="TheCustom">取
                    消</el-button>
            </div>
        </el-dialog>
        <!-- 导入结果说明 -->
        <el-dialog title="导入结果说明" :visible.sync="responseShow" :close-on-click-modal="false" width="960px" id="dialog">
            <div style="height: 574px;overflow: auto;">
                <div class="prompt"
                    style="margin-top: 5px;margin-bottom: 8px;width: calc(100% - 40px);margin-left: 20px;margin-right: 20px;">
                    <i class="el-icon-warning" style="margin-left: 20px;margim-right: 10px;color: #108cee;"></i>
                    <span class="promptFont">{{ modalInfo.message }}</span>
                </div>
                <el-table :data="responseData" style="width: 100%">
                    <el-table-column prop="dealername" label="指派人" />
                    <el-table-column prop="platform" label="购买平台" />
                    <el-table-column prop="productname" label="购买产品" />
                    <el-table-column prop="specification" label="规格" />
                    <el-table-column prop="controlstandard" label="管控标准" />
                    <el-table-column prop="productlink" label="购买链接" />
                    <el-table-column prop="completedate" label="要求购买完成日期">
                        <template slot-scope="scope">
                            {{ scope.row.productlink | fullTime }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="purchaserequirement" label="购买要求" />
                    <el-table-column prop="stopbuyingrequest" label="停止购买要求" />
                    <el-table-column label="错误说明" fixed="right" width="200">
                        <template slot-scope="scope">
                            <span style="color: red;">
                                {{ scope.row.err_info }}
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="responseShow = false" size="small">确
                    定</el-button>
            </div>
        </el-dialog>
        <!-- 任务反馈 -->
        <el-dialog title="任务反馈" :visible.sync="questShow" :close-on-click-modal="false" width="960px" id="dialog">
            <div style="height: 574px;overflow: auto;">
                <el-table :data="questData" style="width: 100%">
                    <el-table-column prop="tasknumber" label="任务编码" />
                    <el-table-column prop="dealername" label="指派人" />
                    <el-table-column prop="feedback" label="反馈" />
                    <el-table-column prop="createtime" label="反馈日期" />
                </el-table>
                <div v-show="this.questData.length > 0">
                    <pagination :currentPage="currentPage2" :pageSizes="[10, 20, 50, 100]" :total="totalNum2"
                        @handleSizeChange="handleSizeChange2" @handleCurrentChange="handleCurrentChange2">
                    </pagination>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="questShow = false" size="small">确
                    定</el-button>
            </div>
        </el-dialog>
        <!-- 经销商反馈 -->
        <el-dialog title="反馈" :visible.sync="TaskShow" width="550px" style="margin-top: 10%;" id="dialog">
            <el-form label-width="70px" :model="form" :rules="rules" ref="form">
                <el-form-item label="反馈" style="margin-top: 20px;" required>
                    <el-select v-model="feedback" clearable placeholder="反馈" style="width: 410px" size="small">
                        <el-option v-for="item in feedbackList" :key="item.value" :label="item.name"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="TaskDealer" size="mini" style="margin-right: 10px;">确
                    定</el-button>
                <el-button @click="TaskShow = false" size="mini" type="TheCustom">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 添加或修改用户配置对话框hcm -->
        <hcmIndexChild ref="hcmIndexChild" @call-parent-method="parentMethod" />
        <hcmIndexChildDealer ref="hcmIndexChildDealer" @call-parent-method="parentMethod" />
    </div>
</template>

<script>
import pagination from "../../../components/dataTable/pagination";
import hcmIndexChild from "./hcmIndexChild.vue";
import hcmIndexChildDealer from "./hcmIndexChildDealer.vue";
export default {
    name: "buyingTaskHCM",
    data() {
        return {
            maihuoList: [{
                name: '未买货',
                key: 0,
            },{
                name: '已买货',
                key: 1,
            }],
            feedback: '',
            feedbackList: [{
                name: '链接下架',
                value: '链接下架',
            }, {
                name: '区域限制',
                value: '区域限制'
            }, {
                name: '库存不足',
                value: '库存不足'
            }, {
                name: '其他',
                value: '其他'
            }],
            buttonText: '批量任务',
            queryParams: {
                pageNo: 1,
                pageSize: 10,
                platform: null,
                shopname: null,
                productname: null,
                specification: null,
                dealername: null,
                tasknumber: null,
                rewardsstatus: null,
            },
            queryParams2: {
                pageNo: 1,
                pageSize: 10,
            },
            totalNum: 0,
            totalNum2: 0,
            openNumber: 0,
            currentPage: 0,
            currentPage2: 0,
            dateRange: [],
            loading: false,
            tableData: [],
            showSearch: true,
            TaskShow: false,
            shopPlatform: [{
                label: '淘宝',
                value: '淘宝'
            }, {
                label: '天猫',
                value: '天猫'
            }, {
                label: '京东',
                value: '京东'
            }, {
                label: '拼多多',
                value: '拼多多'
            }, {
                label: '抖音',
                value: '抖音'
            }, {
                label: '闲鱼',
                value: '闲鱼'
            }, {
                label: '快手',
                value: '快手'
            }, {
                label: '唯品会',
                value: '唯品会'
            }, {
                label: '微信小程序',
                value: '微信小程序'
            }],
            appointorList: [],
            logintype: '',
            delType: '',
            checkAll: '',
            ficationLoading: false,
            deleteShow: false,
            designateShow: false,
            questShow: false,
            form: {
                dealerid: '',
                dealername: ''
            },
            dealernameList: [],
            rules: {
                dealerid: [
                    { required: true, message: '请输入停止购买要求', trigger: 'blur' },
                ]
            },
            bulLoading: false,
            BulkImportShow: false,
            selectRows: [],
            delIds: '',
            responseShow: false,
            responseData: [],
            modalInfo: {},
            questData: [],
            taskData: {},
        };
    },
    components: {
        pagination, hcmIndexChild, hcmIndexChildDealer
    },
    created() {
        this.getList();
        this.logintype = JSON.parse(localStorage.getItem('userData')).logintype;
        if (this.logintype === 'HCM') {
            this.buttonText = '批量任务'
        } else {
            this.buttonText = '批量买货'
        }
        this.getOrderTaskBmcDealerName();
    },
    methods: {
        // 经销商买货
        handleUpdate(data) {
            console.log(data);
            this.$refs.hcmIndexChildDealer.handleAdd(data,'买货录入');
        },
        // 经销商反馈
        dealerTask(data) {
            this.taskData.tasknumber = data.tasknumber;
            this.taskData.dealerid = data.dealerid;
            this.taskData.dealername = data.dealername;
            this.taskData.taskid = data.id;
            this.TaskShow = true
        },
        // 经销商反馈
        TaskDealer() {
            if (this.feedback === '') {
                this.$message.warning('请选择反馈内容')
                return
            }
            this.taskData.feedback = this.feedback;
            fetch({
                url: "hcm/hcmOrdertaskbmc/saveFeedback",
                method: "post",
                data: JSON.stringify(this.taskData),
                headers: {
                    'Content-Type': 'application/json',
                },
                noFormat: false,
                responseType: "json"
            }).then(result => {
                console.log(result)
                if (result.status == '10000') {
                    this.TaskShow = false
                    this.$message({
                        message: '反馈成功',
                        type: 'success'
                    });
                    this.getList();
                } else {
                    this.$message.error(result.message);
                }
            })
        },
        // hcm任务反馈
        taskFeedback() {
            fetch({
                url: "hcm/hcmOrdertaskbmc/getFeedbackPage",
                method: "get",
                params: this.queryParams2,
                noFormat: true,
                responseType: "text"
            }).then((res) => {
                let result = JSON.parse(res)
                if (result.status == '10000') {
                    this.questData = result.data.content;
                    this.totalNum2 = result.data.totalElements;
                    this.questShow = true;
                }
            })
        },
        download() {
            window.open("https://hawksights.obs.cn-east-2.myhuaweicloud.com/system/%E6%89%B9%E9%87%8F%E4%BB%BB%E5%8A%A1%E6%A8%A1%E6%9D%BF%EF%BC%88%E5%93%81%E7%89%8C%E6%96%B9%EF%BC%89.xlsx");
        },
        // 确定导入
        BulkImport() {
            this.bulLoading = true
            this.$refs.newupload.submit();
        },
        // 取消导入
        BulkImportShowf() {
            this.BulkImportShow = false
            this.$refs.newupload.clearFiles();
        },
        beforeUpload(file) {
            let Xls = file.name
            if (Xls.search("xls") != -1 || Xls.search("xlsx") != -1) {
                return file
            } else {
                this.$message.error('上传文件只能是 xls/xlsx 格式!')
                this.bulLoading = false
                return false
            }
        },
        confirmUpload(response) {
            if (response.status == 10000) {
                if (response.data && response.data.length > 0) {
                    this.$message({
                        message: response.message,
                        type: 'warning'
                    });
                    this.responseShow = true
                    this.responseData = response.data
                    this.modalInfo = response
                } else {
                    this.$message({
                        message: response.message,
                        type: 'success'
                    });
                    this.BulkImportShow = false
                }
                this.bulLoading = false
                this.$refs.newupload.clearFiles();
                this.getList();
            } else {
                this.bulLoading = false
                this.getList();
                this.BulkImportShow = false
                this.$message.error(response.message);
                this.$refs.newupload.clearFiles();
            }
        },
        // 批量指派
        designateAdd() {
            this.form.dealerid = ''
            this.form.dealername = ''
            if (this.checkAll == 2) {
                this.delType = '全部'
                this.delIds = "checkAll"
            } else {
                let arrIds = []
                for (let i in this.selectRows) {
                    arrIds.push(this.selectRows[i].id)
                }
                this.delIds = arrIds.join(',')
            }
            if (this.delIds == '') {
                this.$message({
                    message: '没有选中项',
                    type: 'warning'
                });
                return
            }
            this.getlistOfBmc();
        },
        // 获取指派人名字
        dealChange() {
            for (let a in this.dealernameList) {
                if (this.dealernameList[a].id == this.form.dealerid) {
                    this.form.dealername = this.dealernameList[a].dealername;
                }
            }
            console.log(this.form.dealername)
        },
        getlistOfBmc() {
            fetch({
                url: "hcm/dealer/getlistOfBmc",
                method: "get",
                noFormat: true,
                responseType: "text"
            }).then((res) => {
                let result = JSON.parse(res)
                if (result.status == '10000') {
                    this.dealernameList = result.data
                    this.designateShow = true;
                }
            })
        },
        // 勾选
        toggleSelection(rows) {
            if (rows) {
                rows.forEach(row => {
                    this.$refs.multipleTable.toggleAllSelection(row);
                    this.openNumber = this.totalNum
                    this.checkAll = 2
                    // totalNum
                });
            } else {
                this.$refs.multipleTable.clearSelection();
                this.checkAll = 1
                this.openNumber = 0
            }
        },
        handleSelectionChange(val) {
            if (this.checkAll != 2) {
                this.openNumber = val.length;
                this.selectRows = val;
            }
        },
        // 删除
        onOpenDeleteDia(e, ids) {
            this.delIds = ''
            if (ids && e == 1) {
                this.delType = '该'
                this.delIds = ids
            } else if (this.checkAll == 2 && e == 2) {
                this.delType = '全部'
                this.delIds = "checkAll"
            } else {
                this.delType = this.openNumber + '条'
                let arrIds = []
                for (let i in this.selectRows) {
                    arrIds.push(this.selectRows[i].id)
                }
                this.delIds = arrIds.join(',')
            }
            if (this.delIds == '') {
                this.$message({
                    message: '没有选中项',
                    type: 'warning'
                });
                return
            }
            this.deleteShow = true
        },
        // 取消删除
        delCancel() {
            this.deleteShow = false
            this.delType = ''
            this.checkAll = ''
            this.delIds = ''
        },
        // 确认删除
        deleteClassification() {
            this.ficationLoading = true
            let params = {
                ...this.queryParams,
                ids: this.delIds,
            }
            fetch({
                url: "/hcm/hcmOrdertaskbmc/deleteTaskBmc",
                method: "post",
                data: params,
                noFormat: true,
                responseType: "text"
            }).then(result => {
                let res = JSON.parse(result);
                let { data } = res
                if (res.status == '10000') {
                    this.ficationLoading = false
                    this.deleteShow = false
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    this.getList();
                } else {
                    this.ficationLoading = false
                    this.$message.error(res.message);
                }
            })
        },
        // 确认指派
        assignTaskDealer() {
            let params = {
                ...this.queryParams,
                ids: this.delIds,
                dealerid: this.form.dealerid,
                dealernameu: this.form.dealername,
            }
            fetch({
                url: "/hcm/hcmOrdertaskbmc/assignTaskDealer",
                method: "post",
                data: params,
                noFormat: true,
                responseType: "text"
            }).then(result => {
                let res = JSON.parse(result);
                let { data } = res
                if (res.status == '10000') {
                    this.designateShow = false
                    this.$message({
                        message: '指派成功',
                        type: 'success'
                    });
                    this.getList();
                } else {
                    this.$message.error(res.message);
                }
            })
        },
        getOrderTaskBmcDealerName() {
            fetch({
                url: "hcm/hcmOrdertaskbmc/getOrderTaskBmcDealerName",
                method: "get",
                noFormat: true,
                responseType: "text"
            }).then((res) => {
                let result = JSON.parse(res)
                if (result.status == '10000') {
                    this.appointorList = result.data;
                }
            })
        },
        parentMethod() {
            this.getList();
        },
        dataChange() {
            if (!this.dateRange) {
                this.dateRange = []
            }
            this.queryParams.begintime = this.dateRange[0] ? this.dateRange[0] : null
            this.queryParams.endtime = this.dateRange[1] ? this.dateRange[1] : null
        },
        // hcm详情
        taskidFun(data) {
            if (data.rewardsstatus == 1) {
                return
            }
            let params = {
                id: data.id
            }
            fetch({
                url: "hcm/hcmOrdertaskbmc/getOrderTaskbmcDetails",
                method: "get",
                params: params,
                noFormat: true,
                responseType: "text"
            }).then((res) => {
                let result = JSON.parse(res)
                if (result.status == '10000') {
                    this.$refs.hcmIndexChild.handleAdd(result.data.details);
                }
            })
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNo = 1;
            this.dataChange();
            this.getList();
        },
        // 数据源
        getList() {
            this.loading = true;
            fetch({
                url: "hcm/hcmOrdertaskbmc/getList",
                method: "get",
                params: this.queryParams,
                noFormat: true,
                responseType: "text"
            }).then((res) => {
                let result = JSON.parse(res)
                if (result.status == '10000') {
                    this.tableData = result.data.content;
                    this.totalNum = result.data.totalElements;
                    this.loading = false;
                }
            })
        },
        // 下载数据
        importTemplate() {
            fetch({
                url: "hcm/hcmOrdertaskbmc/hcmOrderTaskBmcDownload",
                method: "get",
                params: this.queryParams,
                noFormat: true,
                responseType: "blob"
            }).then((res) => {
                //下载
                let url = window.URL.createObjectURL(new Blob([res]))
                let link = document.createElement('a')
                link.style.display = 'none'
                link.href = url
                link.setAttribute('download', '买货任务.xlsx')
                document.body.appendChild(link)
                link.click()
            })
        },
        // 新增
        handleAdd() {
            this.$refs.hcmIndexChild.handleAdd();
        },
        // 批量新增
        allHandleAdd() {
            if (this.buttonText == '批量任务') {
                this.BulkImportShow = true
            } else {

            }
        },
        handleSizeChange(val) {
            this.queryParams.pageSize = `${val}`
            this.getList();
        },
        handleCurrentChange(val) {
            this.queryParams.pageNo = `${val}`
            this.getList();
        },
        handleSizeChange2(val) {
            this.queryParams2.pageSize = `${val}`
            this.taskFeedback();
        },
        handleCurrentChange2(val) {
            this.queryParams2.pageNo = `${val}`
            this.taskFeedback();
        },
    }
};
</script>
<style lang="scss">
#buyingTaskHCM {
    .prompt {
        height: 28px;
        border: 1px solid #108cee;
        background-color: #e6f7ff;
        border-radius: 5px;
        line-height: 28px;
        margin-top: 8px;
        margin-bottom: 8px;
    }

    .promptFont {
        color: #108cee;
        font-size: 14px;
        margin-left: 3px;
        margin-right: 3px;
    }

    .promptFont2 {
        color: #108cee;
        font-size: 14px;
        margin-left: 3px;
        margin-right: 3px;
        cursor: pointer;
    }

    .el-table th {
        background-color: #f3f7ff !important;
    }

    .el-table__empty-text {
        padding-top: 100px;
        background: url("../../../assets/img/other/nodata.svg") no-repeat;
        background-position: center 66px;
    }

    .el-dialog__header {
        padding: 20px 20px 10px;
        border-bottom: 1px solid #d9d9d9;
    }

    .el-table thead {
        color: #333333;
        font-weight: 500;
    }

    .el-button+.el-button {
        margin-left: 0px;
    }

    .bottom_page .el-pagination {
        text-align: right;
        margin-top: 0px;
        padding-bottom: 0px;
    }
}
</style>